export const SET_REGISTER_INFO = 'setRegisterInfo';
export const SET_PROCESS_REGISTER = 'setProcessRegister';
